import React, { Fragment, FunctionComponent, useState } from 'react'
import { Header } from 'src/components/calendar/Header'
import { Event } from 'src/components/calendar/event'

interface Props {
  data: any,
  timeSlotData: any,
  loading: Boolean,
  slug: String,
  viewer: any,
}

const EventPageLayoutComponent: FunctionComponent<Props> = ({
  data,
  timeSlotData,
  loading,
  slug,
  viewer,
}) => {
  const eventTimeSlotData = timeSlotData && timeSlotData.event

  const eventData = data && data.event

  const renderHeader = (setTicketButtonText: Function, ticketButtonText: string) => (
    <Fragment>
      <Header
        eventData={eventData}
        loading={loading}
        isEventSet={false}
        setTicketButtonText={setTicketButtonText}
        ticketButtonText={ticketButtonText}
      />
      <Event
        slug={slug}
        eventData={eventData}
        loading={loading}
        isEventSet={false}
        isTimedEntry={eventData && eventData.timedEntry}
        eventTimeSlotData={eventTimeSlotData}
        ticketButtonText={ticketButtonText}
        viewer={viewer}
      />
    </Fragment>
  )

  if (loading) {
    return renderHeader(null, null)
  }
  const [ticketButtonText, setTicketButtonText] = useState(eventData.getTicketsText)
  return renderHeader(setTicketButtonText, ticketButtonText)
}

export const EventPageLayout = EventPageLayoutComponent
